import { sortBy } from './sort.ts';

export type AllDishesType = any[] | null | undefined;

export const AVERAGE_NUMBER_OF_RESTAURANTS = 40;

export function sortMostPopular(dishes: AllDishesType) {
  return sortBy(dishes ?? [], v => [v.likesCount], ['desc']);
}

export function sortMostExpensive(dishes: AllDishesType) {
  return sortBy(dishes ?? [], v => [v.prices?.[0]?.price], ['desc']);
}

export function sortLeastExpensive(dishes: AllDishesType) {
  return sortBy(dishes ?? [], v => [v.prices?.[0]?.price], ['asc']);
}
